import { render, staticRenderFns } from "./PortfolioListDefaultLayout.vue?vue&type=template&id=0ce80d24&scoped=true"
import script from "./PortfolioListDefaultLayout.vue?vue&type=script&lang=js"
export * from "./PortfolioListDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce80d24",
  null
  
)

export default component.exports